import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import minicartQuery from '~/graphql/cart/minicart.gql';
import createNewCartMutation from '~/graphql/cart/createNewCart.gql';
import addProductsToCartMutation from '~/graphql/cart/addProductsToCart.gql';
import updateCartMutation from '~/graphql/cart/updateCart.gql';

const token = () => window.localStorage.MDM_AUTH_TOKEN;

function fetchCart(_x, _x2) {
  return _fetchCart.apply(this, arguments);
}

function _fetchCart() {
  _fetchCart = _asyncToGenerator(function* (context, payload) {
    const locale = context.state.i18n.currentLocale.iso;
    const {
      data
    } = yield context.app.apolloProvider.defaultClient.query({
      query: minicartQuery,
      variables: {
        locale,
        token: token(),
        cartId: payload
      }
    });
    return data;
  });
  return _fetchCart.apply(this, arguments);
}

function createCart(_x3) {
  return _createCart.apply(this, arguments);
}

function _createCart() {
  _createCart = _asyncToGenerator(function* (context) {
    const locale = context.state.i18n.currentLocale.iso;
    const {
      data
    } = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: createNewCartMutation,
      variables: {
        locale,
        token: token()
      }
    });
    return data;
  });
  return _createCart.apply(this, arguments);
}

function addCart(_x4, _x5) {
  return _addCart.apply(this, arguments);
} // async function addCartCustomizable(context, payload) {
//   const locale = context.state.i18n.currentLocale;
//   const xhrUri = `${context.state.sharedEnv.payload.web}${locale.market}/${locale.language}/custom/panier/${payload}`;
//   const { data } = await context.$axios.get(xhrUri, {
//     'axios-retry': {
//       retries: 0,
//     },
//   });
//   return data;
// }


function _addCart() {
  _addCart = _asyncToGenerator(function* (context, payload) {
    const locale = context.state.i18n.currentLocale.iso;
    const {
      data
    } = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: addProductsToCartMutation,
      variables: {
        locale,
        token: token(),
        cartId: payload.token,
        products: [{
          reference: payload.reference,
          quantity: payload.quantity
        }]
      }
    });
    return data;
  });
  return _addCart.apply(this, arguments);
}

function updateCart(_x6, _x7) {
  return _updateCart.apply(this, arguments);
}

function _updateCart() {
  _updateCart = _asyncToGenerator(function* (context, payload) {
    const locale = context.state.i18n.currentLocale.iso;
    const {
      data
    } = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: updateCartMutation,
      variables: {
        locale,
        token: token(),
        cartId: payload.token,
        items: [{
          id: payload.id,
          quantity: payload.quantity
        }]
      }
    });
    return data;
  });
  return _updateCart.apply(this, arguments);
}

export { fetchCart, createCart, addCart, updateCart };